module.exports = __webpack_public_path__ + "static/media/iconNavegaIlimitado.db3b25e6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/assets/iconNavegaIlimitado.svg
// module id = 108
// module chunks = 0